import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import cn from 'classnames'
import {currentSubjectSelector} from '../../modules/subjects'
import {checkedCategoriesIdsSelector, categoriesCursorSelector, setCategoryCheckedState, setCategoriesCursor, categoriesTreeMapSelector} from '../../modules/categories'
import {checkAndUploadQuestions} from '../../modules/questions'
import Loader from '../common/Loader'
import ButtonPanel from './ButtonPanel'
import {QBM_CRUD, showModal} from '../../modules/modals'
import {sortCB} from '../../helpers/common'
import toggleOpen from "../../decorators/toggleOpen"
import Statistic from './Statistic'
import { Watch } from 'scrollmonitor-react'
import {CLICK_CREATE_CATEGORY_STEP} from "../../modules/tutorial"
import {QBM_NAV_CATEGORIES} from '../../modules/app'
import { isTeacherOrganisationSelector } from '../../modules/profile'
import {toastr} from 'react-redux-toastr'
import ModalShareCategories from './ModalShareCategories/ModalShareCategories'


class Categories extends Component {
    render() {
        const {openItemId, onClick} = this.props
        const isOpen = openItemId === QBM_NAV_CATEGORIES
        const {formatMessage} = this.context
        return (
            <div className="qbm-accordion-component">
                <div className="qbm-accordion-title"  onClick={onClick}>{formatMessage("Categories")}
                    <div className={cn({"qbm-accordion-arrow":1, open : isOpen})}></div>
                </div>
                <div className={cn({"qbm-accordion-body":1, open : isOpen})}>
                    {
                        this.getBody()
                    }
                </div>
            </div>
        )
    }

    getBody = () => {
        const {currentSubject, loadState : {categoriesLoading}, categoriesCursor, categoriesTree, checkedCategoriesIds} = this.props
        const {ChooseSubject, CategoryItem, ButtonPanelStatistic} = this
        ChooseSubject.displayName = "ChooseSubject"
        CategoryItem.displayName = "CategoryItem"
        ButtonPanelStatistic.displayName = "ButtonPanelStatistic"
        if (!currentSubject) return <ChooseSubject />
        if (categoriesLoading) return <Loader className="accordion-sidebar-preloader" />

        return (
            <React.Fragment>
                <div className="qbm-accordion-content">
                    {
                        !categoriesTree.length &&
                        <span className="qbm-accordion-content__item-text qbm-accordion-content__item-text--no-x-borders">{this.context.formatMessage("There is no category for this subject")}</span>
                    }
                    {
                        categoriesTree
                            .sort(sortCB)
                            .map(cat => {
                                const {id : categoryId, name : categoryName, subcategories} = cat
                                return (
                                    <React.Fragment
                                        key = {categoryId}
                                    >
                                        <CategoryItem
                                            isSubcategory = {false}
                                            isSelected = {categoriesCursor === categoryId}
                                            value = {categoryId}
                                            id = {categoryId}
                                            name = {categoryName}
                                            isChecked = {checkedCategoriesIds.includes(categoryId)}
                                            handleCheck = {this.handleCategoryCheck}
                                            handleClick = {this.handleCategoryClick(categoryId)}
                                        />
                                        {
                                            subcategories
                                                .sort(sortCB)
                                                .map(({id, name}) => {
                                                    return (
                                                        <CategoryItem
                                                            key = {id}
                                                            isSubcategory = {true}
                                                            isSelected = {categoriesCursor === id}
                                                            value = {id}
                                                            id = {id}
                                                            name = {name}
                                                            isChecked = {checkedCategoriesIds.includes(id)}
                                                            handleCheck = {this.handleCategoryCheck}
                                                            handleClick = {this.handleCategoryClick(id)}
                                                        />
                                                    )
                                                })
                                        }
                                    </React.Fragment>
                                )
                            })
                    }
                </div>
                <ButtonPanelStatistic />
            </React.Fragment>
        )
    }

    ButtonPanelStatistic = toggleOpen(props => {
        let {isOpen, toggleOpen} = props
        const {categoriesCursor, isInViewport} = this.props

        return (
            <React.Fragment>
                {
                    <div style={{
                        borderTopWidth: 1,
                        display: 'flex'
                    }} className={cn("qbm-accordion-action-panel", {"qbm-accordion-action-panel--popover" : !isInViewport})}>
                        <Statistic />
                    </div>
                }
                <ButtonPanel
                    handleAddCreateClick = {this.handleActionButtonClick("create")}
                    handleDeleteClick = {this.handleActionButtonClick("delete")}
                    handleUpdateClick = {this.handleActionButtonClick("update")}
                    isUpdateActive = {!!categoriesCursor}
                    isDeleteActive = {!!categoriesCursor}
                    // toggleIcon = {{
                    //     shouldRender : 1,
                    //     isOpen,
                    //     toggleOpen
                    // }}
                    tooltips = {{
                        plus : true,
                        step : CLICK_CREATE_CATEGORY_STEP,
                    }}
                />
            </React.Fragment>
        )
    })

    CategoryItem = ({isSubcategory, isChecked, handleCheck, handleClick, isSelected, value, id, name}) => {
        const {formatMessage} = this.context;
        return (<div
            className={cn({
            "qbm-accordion-content__item" : 1,
            "qbm-accordion-content__item__subitem" : isSubcategory,
            "qbm-accordion-content__item--selected" : isSelected,
            })}
            onClick={handleClick}
        >
            <input
                type="checkbox"
                id={id}
                value={id}
                checked={isChecked}
                onChange={handleCheck}
            />
            <label htmlFor={id}></label>
            <span className="qbm-accordion-content__item__name text-ellipsis" style={{width: '100%'}}>{name}</span>
            <ModalShareCategories categoryId={id} formatMessage={formatMessage} />
        </div>);
    }

    handleActionButtonClick = (action) => () => {
        const {showModal, categoriesCursor, isTeacherOrganisation, permission} = this.props;
        const {formatMessage} = this.context;
        if('delete' == action){
            if(isTeacherOrganisation && permission && !permission.allow_delete_question){
                toastr.warning(formatMessage('notPermissionTitle'), formatMessage('notPermissionMessage'));
                return ;
            }
        }

        if (!categoriesCursor && ["delete", "update"].includes(action)) return
        showModal({modalType : QBM_CRUD, modalProps : {qbmEntity : "category", qbmCrudAction : action}})
    }
    handleCategoryCheck = (event) => {
        const {setCategoryCheckedState, checkAndUploadQuestions} = this.props
        setCategoryCheckedState({id : event.target.value, isChecked:event.target.checked})
        checkAndUploadQuestions()
    }
    handleCategoryClick = (id) => () => {
        const {setCategoriesCursor} = this.props
        setCategoriesCursor(id)
    }
    ChooseSubject = () => (
        <span className="qbm-accordion-content__item-text">{this.context.formatMessage("Choose subject")}</span>
    )
    static contextTypes = {formatMessage: PropTypes.any}
}

export default connect(
    state => {
        const currentSubject = currentSubjectSelector(state)
        let categoriesLoaded, categoriesLoading, categoriesTree
        if (currentSubject) {
            categoriesLoaded = currentSubject.categoriesLoaded
            categoriesLoading = currentSubject.categoriesLoading
            const categoriesIds = currentSubject.categoriesIds.keySeq().toArray()
            categoriesTree = Object.values(categoriesTreeMapSelector(state, categoriesIds))
        } else {
            categoriesTree = []
        }

        return {
            currentSubject,
            categoriesTree,
            loadState : {categoriesLoaded, categoriesLoading},
            categoriesCursor : categoriesCursorSelector(state),
            checkedCategoriesIds : checkedCategoriesIdsSelector(state),
            permission: state.profile.permission || {},
            isTeacherOrganisation: isTeacherOrganisationSelector(state),
        }
    },
    {setCategoryCheckedState, setCategoriesCursor, showModal, checkAndUploadQuestions}
)(Watch(Categories))


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/Categories.js